const validationMessages = {
  login: {
    error: 'Enter valid Email ID and Password',
    email: {
      REQUIRED: 'Email ID is required',
      EMAIL_INVALID: 'Enter valid Email ID',
    },
    password: {
      REQUIRED: 'Password is required',
    },
  },
};

export default validationMessages;
